import styled from "styled-components";
import { theme } from "uikit";

const Label = styled.div`
	height: 16px;

	font-family: "Lato";
	font-style: normal;
	font-weight: 400;
	font-size: 13px;
	line-height: 16px;

	color: ${theme.colors.primary};
`;

export default Label;
